import { Schema as S } from "effect";

const CardSchema = S.Struct({
  cardSlot: S.String,
  cardType: S.String,
  cardID: S.String,
  terminalID: S.String,
});

const TerminalStatusSchema = S.Struct({
  Result: S.String,
});

const TerminalInfoSchema = S.Struct({
  Status: TerminalStatusSchema,
  Cards: S.Array(CardSchema),
});

const DataSchema = S.Record(S.String, TerminalInfoSchema);

export const GetCardsResponseSchema = DataSchema;
export type GetCardsResponse = S.Schema.Type<typeof GetCardsResponseSchema>;
